import store from "@/state/store";

export default [
    {
        path: "/",
        name: "default",
        meta: {
            authRequired: true,
        },
        component: () => import("./views/dashboards/default"),
    },
    {
        path: "/login",
        name: "login",
        component: () => import("./views/account/login"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters["auth/loggedIn"]) {
                    next({ name: "default" });
                } else {
                    next();
                }
            },
        },
    },
    {
        path: "/choose-branch",
        meta: { authRequired: true },
        component: () => import("./views/account/branch"),
    },
    {
        path: "/register",
        name: "Register",
        component: () => import("./views/account/register"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters["auth/loggedIn"]) {
                    next({ name: "default" });
                } else {
                    next();
                }
            },
        },
    },
    {
        path: "/forgot-password",
        name: "Forgot password",
        component: () => import("./views/account/forgot-password"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters["auth/loggedIn"]) {
                    next({ name: "default" });
                } else {
                    next();
                }
            },
        },
    },
    {
        path: "/logout",
        name: "logout",
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                localStorage.removeItem("user");
                localStorage.removeItem("token");
                localStorage.removeItem("branches");
                localStorage.removeItem("financialyear");
                localStorage.removeItem("license");
                localStorage.removeItem("active_license");
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.push("/login"),
                );
                next(
                    authRequiredOnPreviousRoute
                        ? { name: "default" }
                        : { ...routeFrom },
                );
            },
        },
    },
    {
        path: "/404",
        name: "404",
        component: require("./views/utility/404").default,
    },
    {
        path: "*",
        redirect: "404",
    },
    {
        path: "/new-member",
        meta: { authRequired: true },
        component: () => import("./views/members/newmember"),
    },
    {
        path: "/view-members",
        meta: { authRequired: true },
        component: () => import("./views/members/viewmembers"),
    },
    {
        path: "/account-balances",
        meta: { authRequired: true },
        component: () => import("./views/members/account_balances"),
    },
    {
        path: "/member-profile",
        meta: { authRequired: true },
        component: () => import("./views/members/profile"),
    },
    {
        path: "/print-profile",
        meta: { authRequired: true },
        component: () => import("./views/members/printprofile"),
    },
    {
        path: "/membership-fees",
        meta: { authRequired: true },
        component: () => import("./views/members/membershipfees"),
    },
    {
        path: "/registration-fees",
        meta: { authRequired: true },
        component: () => import("./views/members/registrationfees"),
    },
    {
        path: "/print-membership-fee",
        meta: { authRequired: true },
        component: () => import("./views/members/printmembershipfee"),
    },
    {
        path: "/print-registration-fee",
        meta: { authRequired: true },
        component: () => import("./views/members/printregistrationfee"),
    },
    {
        path: "/savings",
        meta: { authRequired: true },
        component: () => import("./views/savings/savings"),
    },
    {
        path: "/print-saving",
        meta: { authRequired: true },
        component: () => import("./views/savings/printsavings"),
    },
    {
        path: "/shares",
        meta: { authRequired: true },
        component: () => import("./views/savings/shares"),
    },
    {
        path: "/print-share",
        meta: { authRequired: true },
        component: () => import("./views/savings/printshare"),
    },
    {
        path: "/withdraws",
        meta: { authRequired: true },
        component: () => import("./views/savings/withdraws"),
    },
    {
        path: "/print-withdraw",
        meta: { authRequired: true },
        component: () => import("./views/savings/printwithdraw"),
    },
    {
        path: "/withdraw-charges",
        meta: { authRequired: true },
        component: () => import("./views/savings/withdrawcharges"),
    },
    {
        path: "/loan-products",
        meta: { authRequired: true },
        component: () => import("./views/loans/loanproducts"),
    },
    {
        path: "/loan-charges",
        meta: { authRequired: true },
        component: () => import("./views/loans/loancharges"),
    },
    {
        path: "/applicants",
        meta: { authRequired: true },
        component: () => import("./views/members/applicants"),
    },
    {
        path: "/loans",
        meta: { authRequired: true },
        component: () => import("./views/loans/loans"),
    },
    {
        path: "/loan-fines",
        meta: { authRequired: true },
        component: () => import("./views/loans/loanfines"),
    },
    {
        path: "/record-expense",
        meta: { authRequired: true },
        component: () => import("./views/expenses/record"),
    },
    {
        path: "/expense-items",
        meta: { authRequired: true },
        component: () => import("./views/expenses/items"),
    },
    {
        path: "/expense-categories",
        meta: { authRequired: true },
        component: () => import("./views/expenses/categories"),
    },
    {
        path: "/view-expenses",
        meta: { authRequired: true },
        component: () => import("./views/expenses/view"),
    },
    {
        path: "/sms-center",
        meta: { authRequired: true },
        component: () => import("./views/smscenter/messages"),
    },
    {
        path: "/sms-purchase",
        meta: { authRequired: true },
        component: () => import("./views/smscenter/smspurchase"),
    },
    {
        path: "/settings",
        meta: { authRequired: true },
        component: () => import("./views/settings/general_settings"),
    },
    {
        path: "/roles",
        meta: { authRequired: true },
        component: () => import("./views/users/roles"),
    },
    {
        path: "/users",
        meta: { authRequired: true },
        component: () => import("./views/users/users"),
    },
    {
        path: "/permissions",
        meta: { authRequired: true },
        component: () => import("./views/users/permissions"),
    },
    {
        path: "/audits",
        meta: { authRequired: true },
        component: () => import("./views/users/audits"),
    },
    {
        path: "/reports",
        meta: { authRequired: true },
        component: () => import("./views/reports/main"),
    },
    {
        path: "/due-loans",
        meta: { authRequired: true },
        component: () => import("./views/reports/dueloans"),
    },
    {
        path: "/expenses-report",
        meta: { authRequired: true },
        component: () => import("./views/reports/expensesreport"),
    },
    {
        path: "/inactive-accounts",
        meta: { authRequired: true },
        component: () => import("./views/reports/inactiveaccounts"),
    },
    {
        path: "/income-and-expenditure",
        meta: { authRequired: true },
        component: () => import("./views/reports/incomeandexpenditure"),
    },
    {
        path: "/loan-charges-report",
        meta: { authRequired: true },
        component: () => import("./views/reports/loanchargesreport"),
    },
    {
        path: "/loan-interests-report",
        meta: { authRequired: true },
        component: () => import("./views/reports/loaninterestsreport"),
    },
    {
        path: "/loan-monthly-report",
        meta: { authRequired: true },
        component: () => import("./views/reports/loanmonthlyreport"),
    },
    {
        path: "/loan-payment-report",
        meta: { authRequired: true },
        component: () => import("./views/reports/loanpaymentreport"),
    },
    {
        path: "/loan-per-products",
        meta: { authRequired: true },
        component: () => import("./views/reports/loanperproducts"),
    },
    {
        path: "/loans-per-member",
        meta: { authRequired: true },
        component: () => import("./views/reports/loanspermember"),
    },
    {
        path: "/loans-per-user",
        meta: { authRequired: true },
        component: () => import("./views/reports/loansperuser"),
    },
    {
        path: "/membership-fees-port",
        meta: { authRequired: true },
        component: () => import("./views/reports/membershipfeesport"),
    },
    {
        path: "/monthly-savings-analysis",
        meta: { authRequired: true },
        component: () => import("./views/reports/monthlysavingsanalysis"),
    },
    {
        path: "/monthly-share-analysis",
        meta: { authRequired: true },
        component: () => import("./views/reports/monthlyshareanalysis"),
    },
    {
        path: "/monthly-withdraws-analysis",
        meta: { authRequired: true },
        component: () => import("./views/reports/monthlywithdrawsanalysis"),
    },
    {
        path: "/savings-per-member",
        meta: { authRequired: true },
        component: () => import("./views/reports/savingspermember"),
    },
    {
        path: "/savings-per-user",
        meta: { authRequired: true },
        component: () => import("./views/reports/savingsperuser"),
    },
    {
        path: "/shares-per-member",
        meta: { authRequired: true },
        component: () => import("./views/reports/sharespermember"),
    },
    {
        path: "/shares-per-user",
        meta: { authRequired: true },
        component: () => import("./views/reports/sharesperuser"),
    },
    {
        path: "/transactions-report",
        meta: { authRequired: true },
        component: () => import("./views/reports/transactionsreport"),
    },
    {
        path: "/withdraw-charges-report",
        meta: { authRequired: true },
        component: () => import("./views/reports/withdrawchargesreport"),
    },
    {
        path: "/withdraws-per-member",
        meta: { authRequired: true },
        component: () => import("./views/reports/withdrawspermember"),
    },
    {
        path: "/withdraws-per-user",
        meta: { authRequired: true },
        component: () => import("./views/reports/withdrawsperuser"),
    },
    {
        path: "/written-off-loans",
        meta: { authRequired: true },
        component: () => import("./views/reports/writtenoffloans"),
    },
    {
        path: "/investments",
        meta: { authRequired: true },
        component: () => import("./views/returns/investments"),
    },
    {
        path: "/investment-returns",
        meta: { authRequired: true },
        component: () => import("./views/returns/investmentreturns"),
    },
    {
        path: "/member-interests",
        meta: { authRequired: true },
        component: () => import("./views/returns/memberinterests"),
    },
    {
        path: "/dividend-payouts",
        meta: { authRequired: true },
        component: () => import("./views/returns/dividendpayouts"),
    },
    {
        path: "/shareholder-dividends",
        meta: { authRequired: true },
        component: () => import("./views/returns/shareholderdividends"),
    },
    {
        path: "/interest-payouts",
        meta: { authRequired: true },
        component: () => import("./views/returns/interestpayouts"),
    },
    {
        path: "/subscriptions",
        meta: { authRequired: true },
        component: () => import("./views/settings/subscriptions.vue"),
    },
    {
        path: "/expired-license",
        meta: { authRequired: true },
        component: () => import("./views/settings/expiredSubscription.vue"),
    },
    {
        path: "/online-transactions",
        meta: { authRequired: true },
        component: () => import("./views/payments/onlineTransactions.vue"),
    },
    {
        path: "/request-payout",
        meta: { authRequired: true },
        component: () => import("./views/payments/requestPayout.vue"),
    },
    {
        path: "/payout-history",
        meta: { authRequired: true },
        component: () => import("./views/payments/payoutHistory.vue"),
    },
    {
        path: "/checkoff-lists",
        meta: { authRequired: true },
        component: () => import("./views/payroll_deductions/viewcheckoffs.vue"),
    },
    {
        path: "/new-checkoff-list",
        meta: { authRequired: true },
        component: () => import("./views/payroll_deductions/newcheckoff.vue"),
    },
    {
        path: "/print-checkoff",
        meta: { authRequired: true },
        component: () => import("./views/payroll_deductions/printcheckoff.vue"),
    },
    // {
    //     path: "/deduction-requests",
    //     meta: { authRequired: true },
    //     component: () => import("./views/payroll_deductions/deductionrequests.vue"),
    // },
    {
        path: "/credit-score",
        name: "credit-form",
        meta: { authRequired: true },
        component: () => import("./views/creditscore/creditform.vue"),
    },
    {
        path: "/credit-report",
        name: "creditreport",
        meta: { authRequired: true },
        component: () => import("./views/creditscore/creditreport.vue"),
    },
    {
        path: "/credit-reports",
        name: "credit-reports",
        meta: { authRequired: true },
        component: () => import("./views/creditscore/creditreports.vue"),
    },
    {
        path: "/contributions",
        meta: { authRequired: true },
        component: () => import("./views/welfare/contributions.vue"),
    },
    {
        path: "/give-away",
        meta: { authRequired: true },
        component: () => import("./views/welfare/giveAway.vue"),
    },

    {
        path: "/new-document",
        meta: { authRequired: true },
        component: () => import("./views/documents/new_document.vue"),
    },
    {
        path: "/documents",
        meta: { authRequired: true },
        component: () => import("./views/documents/documents.vue"),
    },
    {
        path: "/document-types",
        meta: { authRequired: true },
        component: () => import("./views/documents/document_types.vue"),
    },
    {
        path: "/new-crb-report",
        meta: { authRequired: true },
        component: () => import("./views/crb/new_crb_report.vue"),
    },
    {
        path: "/crb-reports",
        meta: { authRequired: true },
        component: () => import("./views/crb/crb_reports.vue"),
    },
    {
        path: "/crb-tokens",
        meta: { authRequired: true },
        component: () => import("./views/crb/crb_tokens.vue"),
    },
    {
        path: "/pages/404",
        name: "Error-404",
        meta: { authRequired: true },
        component: () => import("./views/utility/404"),
    },
    {
        path: "/pages/500",
        name: "Error-500",
        meta: { authRequired: true },
        component: () => import("./views/utility/500"),
    },
];
